var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-link button-flag",class:{ flagged: _vm.hasFlag },attrs:{"type":"button","title":_vm.flagBtnTitle,"disabled":_vm.flagBtnDisabled},on:{"click":_vm.setFlag}})}
var staticRenderFns = []

export { render, staticRenderFns }